export const PWA_UPDATE_AVAILABLE_EVENT = "metajuntos:pwa-update-available";

export type PwaUpdateAvailableEvent = CustomEvent<{
  registration: ServiceWorkerRegistration;
}>;

export function registerServiceWorker() {
  if (import.meta.env.DEV) return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    let updateNotified = false;
    let refreshing = false;

    window.setTimeout(() => {
      sessionStorage.removeItem("metajuntos:pwa-reloaded");
    }, 5000);

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      if (sessionStorage.getItem("metajuntos:pwa-reloaded") === "1") return;

      refreshing = true;
      sessionStorage.setItem("metajuntos:pwa-reloaded", "1");
      console.info("[PWA] Service worker updated");
      window.location.reload();
    });

    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data?.type === "PWA_UPDATED") {
        console.info("[PWA] Service worker updated", event.data.version);
      }
    });

    const notifyUpdateAvailable = (registration: ServiceWorkerRegistration) => {
      if (updateNotified) return;
      if (!navigator.serviceWorker.controller) return;
      if (!registration.waiting) return;

      updateNotified = true;
      window.dispatchEvent(
        new CustomEvent(PWA_UPDATE_AVAILABLE_EVENT, {
          detail: { registration },
        })
      );
      activateWaitingServiceWorker(registration);
    };

    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        notifyUpdateAvailable(registration);

        registration.addEventListener("updatefound", () => {
          const installingWorker = registration.installing;
          if (!installingWorker) return;

          installingWorker.addEventListener("statechange", () => {
            if (installingWorker.state === "installed") {
              notifyUpdateAvailable(registration);
            }
          });
        });

        registration.update().catch((error) => {
          console.warn("Erro ao procurar atualizacao do PWA:", error);
        });
      })
      .catch((error) => {
        console.warn("Erro ao registrar service worker do MetaJuntos:", error);
      });
  });
}

export function activateWaitingServiceWorker(
  registration: ServiceWorkerRegistration | null
) {
  registration?.waiting?.postMessage({ type: "SKIP_WAITING" });
}
